import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SavedFiltersRepository } from '../../../infrastructure/repositories/saved-filters.repository';
import { GetSavedFiltersResult } from './get-saved-filters.result';

@Injectable({ providedIn: 'root' })
export class GetSavedFiltersUseCase {
  private readonly _repository = inject(SavedFiltersRepository);

  public execute(): Observable<GetSavedFiltersResult> {
    return this._repository.getSavedFilters().pipe(
      map((savedFilters) => ({ savedFilters })),
    );
  }
}
